import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ProviderConfigForm from '../components/ProviderConfigForm';
import ProvidersList from '../components/providers/ProvidersList';
import { useProvidersData } from '../hooks/useProvidersData';

interface DNSProvider {
  id: string;
  name: string;
  type: string;
  status: 'active' | 'inactive' | 'error' | 'syncing';
  zones: number;
  lastSync: string;
  config: Record<string, any>;
  syncEnabled?: boolean;
  errorMessage?: string;
}

const Providers: React.FC = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [editProvider, setEditProvider] = useState<DNSProvider | null>(null);

  const {
    providers,
    loading,
    syncingProviders,
    loadProviders,
    handleAddProvider,
    handleUpdateProvider,
    handleSyncProvider,
    handleDeleteProvider,
  } = useProvidersData();

  return (
    <motion.div
      className="space-y-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <ProvidersList
        providers={providers.map((p) => ({
          id: p.id,
          name: p.name,
          type: p.type,
          status: p.status,
          configuration: p.config || {},
          lastSync: p.lastSync,
          isLoading: syncingProviders.has(p.id),
        }))}
        isLoading={loading}
        error={null}
        onAddProvider={() => setShowAddModal(true)}
        onEditProvider={(prov) => {
          const found = providers.find((p) => p.id === prov.id);
          if (found) setEditProvider(found);
        }}
        onDeleteProvider={handleDeleteProvider}
        onSyncProvider={handleSyncProvider}
        onToggleProviderStatus={() => loadProviders()}
      />

      <ProviderConfigForm
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSubmit={handleAddProvider}
      />

      {editProvider && (
        <ProviderConfigForm
          isOpen={!!editProvider}
          onClose={() => setEditProvider(null)}
          onSubmit={(data) => handleUpdateProvider(editProvider.id, data)}
          mode="edit"
          initial={{ name: editProvider.name, type: editProvider.type }}
        />
      )}
    </motion.div>
  );
};

export default Providers;
